/**
 * Legal documents (single client-side source of truth for the rendered text).
 * Versions must match server/src/legal/legalVersions.ts — tests/legalDocuments.test.js pins the
 * structure; bump BOTH sides together on any material change.
 */
export { CONSUMER_TERMS } from './consumerTerms.ts';
export { PARTNER_TERMS } from './partnerTerms.ts';
export { PRIVACY_POLICY } from './privacyPolicy.ts';
// The APP 5 collection notice is shown, not accepted: it is deliberately NOT in LEGAL_DOCUMENTS
// (the acceptance ledger's document set is a database constraint).
export { COLLECTION_NOTICE } from './collectionNotice.ts';

import { CONSUMER_TERMS } from './consumerTerms.ts';
import { PARTNER_TERMS } from './partnerTerms.ts';
import { PRIVACY_POLICY } from './privacyPolicy.ts';

export const LEGAL_DOCUMENTS = {
  consumer_terms: CONSUMER_TERMS,
  partner_terms: PARTNER_TERMS,
  privacy_policy: PRIVACY_POLICY,
};
